
























import { Component, Prop, Vue } from "vue-property-decorator";
import { MenuItem } from "@/components/Menu/menu-item";

@Component({})
export default class MenuOption extends Vue {
  @Prop() public item!: MenuItem;
  @Prop() public rootOption!: boolean;

  public get OptionActive(): boolean {
    if (this.$route.fullPath === this.item.link) {
      return true;
    }
    // For items with sub-views (lista + formulario), activate when on any sub-route
    // e.g. /main/crm/ventas/lista and /main/crm/ventas/formulario/1 share section /main/crm/ventas
    // Items with < 4 segments (/main/crm/clients) only match exactly to avoid false positives
    const linkSegments = this.item.link.split('/').filter((s: string) => s);
    if (linkSegments.length >= 4) {
      const sectionPath = '/' + linkSegments.slice(0, -1).join('/');
      return this.$route.fullPath.startsWith(sectionPath + '/') ||
             this.$route.fullPath === sectionPath;
    }
    return false;
  }

  public get stilo() {
    if (this.OptionActive) {
      return "font-size: 1.1rem; color: #ffffff;";
    }
    return "font-size: 1.1rem; color: #718096;";
  }

  public OptionClick() {
    this.$router.push(this.item.link);
  }
}
